import React from "react";

import moment from "moment";

import { formatDayMonth, useTranslation } from "utils";

import { Card, Icon, Trans, Typography } from "components";

const getColor = (completed, daysToDeadline) => {
  if (completed) {
    return "green";
  }

  if (daysToDeadline < 0) {
    return "red";
  }

  if (daysToDeadline < 4) {
    return "orange";
  }

  return "";
};

export const TaskCard = ({ documentName, year, deadline, completed, onClick, dataTestId, showDeadline = true }) => {
  const { t } = useTranslation("tasks");

  const daysToDeadline = moment(deadline).diff(moment(), "days", true);
  const isLate = daysToDeadline < 0;

  return (
    <Card
      className={`task-card ${completed ? "completed" : ""} ${onClick ? "pointer" : ""}`}
      onClick={onClick}
      mixpanelText="task-card"
      dataTestId={dataTestId}
    >
      {showDeadline && daysToDeadline < 4 && !completed && (
        <div className={`warning-header ${getColor(completed, daysToDeadline)}`}>
          <Icon iconName={`${isLate ? "tabler/alert-triangle" : "tabler/clock"}`} className="icon inline" />

          <Typography variant="paragraph-s" color={completed ? "grey-500" : undefined}>
            {isLate
              ? t("taskCard.late")
              : t("taskCard.daysLeft", {
                  days: Math.floor(daysToDeadline),
                })}
          </Typography>
        </div>
      )}
      <div className="content">
        <div>
          <Icon iconName={completed ? "tabler/circle-check-filled" : "tabler/file-upload"} size="m" className="margin-right-50" />
        </div>

        <Typography variant="paragraph-m" className="margin-right-100">
          {/* Use Trans to use b tag in translation without using dangerouslySetInnerHtml */}
          <Trans i18nKey="tasks:taskCard.description">
            <b>{{ name: documentName }}</b>
            <b>{{ year }}</b>
          </Trans>
        </Typography>
        {showDeadline ? (
          <span className={`date ${getColor(completed, daysToDeadline)}`}>{completed ? t("taskCard.completed") : formatDayMonth(deadline)}</span>
        ) : (
          completed && <span className="date green">{t("taskCard.completed")}</span>
        )}
      </div>
    </Card>
  );
};
